import { jsx, jsxs } from "react/jsx-runtime";
import { IconButton, Stack, Typography } from "@mui/material";
import { AddCircle, Delete } from "../../../../../../../icons/index.js";
import { Placeholder } from "../../../../Placeholder/Placeholder.js";
import { Swatch } from "../../../../Swatch/Swatch.js";
import { Grid } from "../../Grid/Grid.js";
import { useColorPicker } from "../../../../../index.js";
import { Tooltip } from "../../../../Tooltip.js";
import { useColorGroup } from "../hooks/useColorGroup.js";
import { ColorGroupHeader } from "./ColorGroupHeader/index.js";
function ColorGroup(props) {
  const {
    id,
    colorGroup,
    maxSwatches,
    colorGroup: { label, colors }
  } = props;
  const {
    localeText,
    selection,
    placeholdersCount,
    actions: { addAction, deleteAction, onChange }
  } = useColorGroup(id, colorGroup, maxSwatches);
  const { swatchSize } = useColorPicker();
  return /* @__PURE__ */ jsxs(Stack, { gap: 0.5, display: "inline-flex", "data-testid": "ColorGroup", children: [
    /* @__PURE__ */ jsx(
      ColorGroupHeader,
      {
        label: /* @__PURE__ */ jsx(Typography, { variant: "caption", noWrap: true, children: label }),
        children: /* @__PURE__ */ jsxs(Stack, { flex: 0, direction: "row", children: [
          deleteAction.visible && /* @__PURE__ */ jsx(Tooltip, { placement: "bottom", title: localeText.deleteColorTooltip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
            IconButton,
            {
              "data-testid": "ColorGroup--Delete",
              onClick: deleteAction.onClick,
              disabled: deleteAction.disabled,
              children: /* @__PURE__ */ jsx(Delete, {})
            }
          ) }) }),
          addAction.visible && /* @__PURE__ */ jsx(
            Tooltip,
            {
              placement: "bottom",
              title: addAction.disabled ? localeText.addColorDisabledTooltip : localeText.addColorTooltip,
              children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(IconButton, { "data-testid": "ColorGroup--Add", onClick: addAction.onClick, disabled: addAction.disabled, children: /* @__PURE__ */ jsx(AddCircle, {}) }) })
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsxs(Grid, { testId: "ColorGroup--Grid", children: [
      colors.map((color) => /* @__PURE__ */ jsx(
        Swatch,
        {
          localeText,
          color,
          selected: selection.has(color),
          onSelect: onChange,
          swatchSize
        },
        color
      )),
      Array.from({ length: placeholdersCount }).map((_, idx) => /* @__PURE__ */ jsx(
        Placeholder,
        {
          swatchSize,
          onClick: addAction.onClick,
          disabled: addAction.disabled,
          tooltip: addAction.disabled ? localeText.addColorDisabledTooltip : localeText.addColorTooltip
        },
        idx
      ))
    ] })
  ] }, id);
}
export {
  ColorGroup
};
//# sourceMappingURL=ColorGroup.js.map
